<template>
  <div>
    <div
      v-for="fieldItem in logTypes[data.logId]"
      :key="fieldItem.field"
    >
      <img
        v-if="fieldItem.field === 'ssh'"
        :class="$style.ssh"
        :src="url"
        @click="openModal()"
      >
      <button
        v-else-if="fieldItem.field === 'file' && isViewSaveFile"
        :class="$style.saveFileButton"
        @click="saveFile()"
      >
        {{ $t('pages.saveFile') }}
      </button>
      <div
        v-else-if="
          fieldItem.field !== 'attachments' &&
            fieldItem.field !== 'file' &&
            (data.logId !== 5 || fieldItem.field !== 'text' || data.type === $t('pages.text'))
        "
        :class="$style.detailsItem"
      >
        <div :class="$style.itemHeader">
          {{ fieldItem.text }}:
        </div>
        <div :class="$style.itemContent">
          {{ getCategoryName(data[fieldItem.field]) }}
        </div>
      </div>
    </div>
    <div
      v-if="data.attachments && data.attachments.length"
      :class="$style.detailsItem"
    >
      <div :class="$style.itemHeader">
        {{ $t('common.attachedFiles') }}:
      </div>
      <ul :class="$style.attachmentsList">
        <li
          v-for="attachment in data.attachments"
          :key="attachment.id"
        >
          <p v-if="data.logId === 15">
            {{ getTitle(attachment) }}
          </p>
          <a
            v-else
            href="#"
            @click="saveFile(attachment)"
          >
            {{ getTitle(attachment) }}
          </a>
        </li>
      </ul>
    </div>
    <button
      v-if="data.logId === 15"
      @click="openMail()"
    >
      {{ $t('pages.openEmail') }}
    </button>
    <modal
      v-if="isShowModal"
      :title="data.caption"
      :fullscreen="true"
      @close="close"
    >
      <div :class="$style.content">
        <div :class="$style.imageWrapper">
          <img :src="url">
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import {
    getScreenshotLink,
    getClipboardFileLink,
    getClipboardFile,
    getMicRecordFile,
    getShadowCopyingFile,
    getMessengersAttachment,
    getFileUploadAttachment,
    getPrinterDocumentLink,
    getWebcamsAndMicrophonesFile,
    getEmailClientsMailLink,
  } from '@/api/methods/computers';
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import Modal from '@/components/common/modal/index.vue';
  import { LOG_TYPES_DETAILS } from '@/assets/scripts/details';

  Vue.use(VueToast);

  export default {
    name: 'LogDetails',
    components: {
      Modal,
    },
    props: ['data'],
    data: () => ({
      isShowModal: false,
    }),
    computed: {
      isViewSaveFile() {
        return (
          (this.data.logId === 5 && this.data.type !== this.$t('pages.text')) ||
          ([21, 23].includes(this.data.logId) && this.data?.attachment) ||
          [6, 14, 24, 27].includes(this.data.logId)
        );
      },
      logTypes() {
        return LOG_TYPES_DETAILS;
      },
      url() {
        if (this.data.logId === 2) {
          return getScreenshotLink(this.data.compId, this.data.path);
        }
        if (this.data.logId === 5 && this.data.type === this.$t('pages.screenshot')) {
          return getClipboardFileLink(this.data.compId, this.data.id);
        }
        return null;
      },
    },
    methods: {
      getTitle(attachment) {
        return attachment.size
          ? `${decodeURIComponent(attachment.filename)} (${attachment.size}kB)`
          : decodeURIComponent(attachment.filename);
      },
      getCategoryName(name) {
        const isDbString = typeof name === 'string' && name.startsWith('$');
        return isDbString ? this.$t(`db.${name}`) : name;
      },
      openModal() {
        this.isShowModal = true;
        this.$router.replace({
          query: {
            ...this.$route.query,
            modal: null,
          },
        });
      },
      close() {
        this.isShowModal = false;
        const query = { ...this.$route.query };
        delete query.modal;

        this.$router.replace({
          query,
        });
      },
      async saveFile(attachment = null) {
        let result = null;
        switch (this.data.logId) {
          case 5: {
            result = await getClipboardFile(this.data.compId, this.data.id);
            break;
          }
          case 6: {
            result = await getPrinterDocumentLink(this.data.compId, this.data.id);
            break;
          }
          case 14: {
            result = await getShadowCopyingFile(this.data.compId, this.data.id);
            break;
          }
          case 21: {
            result = await getFileUploadAttachment(this.data.compId, this.data.id, attachment.id, attachment.filename);
            break;
          }
          case 23: {
            result = await getMessengersAttachment(this.data.compId, this.data.id, this.data.attachment.filename);
            break;
          }
          case 24: {
            result = await getWebcamsAndMicrophonesFile(this.data.compId, this.data.id);
            break;
          }
          case 27: {
            result = await getMicRecordFile(this.data.compId, this.data.id);
            break;
          }
          default: {
            break;
          }
        }
        if (!result.success) {
          Vue.$toast.open({
            message: result.message,
            type: 'error',
          });
        }
      },

      openMail() {
        const { compId, id } = this.data;
        const url = getEmailClientsMailLink(compId, id);
        window.open(url, '_blank');
      },
    },
  };
</script>

<style lang="scss" module>
  .detailsItem {
    display: flex;
  }

  .itemHeader {
    margin: 5px;
    font-weight: 500;
    min-width: 100px;
  }

  .itemContent {
    margin: 5px;
  }

  .ssh {
    width: 70%;
    margin: 7px;
  }

  .saveFileButton {
    cursor: pointer;
    display: block;
    width: 130px;
    height: 28px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin: 5px;
  }

  .content {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .imageWrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 30px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }

  .attachmentsList {
    font-size: 12px;
    padding: 5px;

    li {
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
</style>
